function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h34v34H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 22h2.835c.642 0 1.165-.524 1.165-1.17V9.17C26 8.583 25.476 8 24.83 8H13.17C12.583 8 12 8.583 12 9.17V12",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 13.007C8 12.45 8.45 12 9.007 12h11.986c.556 0 1.007.45 1.007 1.007v11.986C22 25.55 21.55 26 20.993 26H9.007C8.45 26 8 25.55 8 24.993V13.007z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34
  }, props), _ref);
}
export default SvgCopy;